import React from 'react';

import { Typography } from '@mui/material';

import CommentIcon from '@common/assets/icons/Comment.svg';

import * as Styled from './styled';

interface PropsType {
	comment?: string;
}

function GradeGridComment({ comment }: PropsType) {
	if (!comment) return null;

	return (
		<Styled.Wrap className="comment">
			<Typography variant="subtitle2">
				{/* @TODO add security  */}
				<CommentIcon /> - <Styled.CommentContent dangerouslySetInnerHTML={{ __html: comment }} />
			</Typography>
		</Styled.Wrap>
	);
}

export default GradeGridComment;
